export default "__VITE_ASSET__BZRXRfJB__"